import { Typography, Link, Box } from '@mui/material';
import logoAscoprel from '../../../images/ascoprel_horizontal.png'

export function HeaderLogin() {
    return (
        <Box component="div" noValidate align="center">
            {/* <Avatar src={logoCoprel} sx={{ m: 5, borderRadius: '50% 50% 50% 0px' }}></Avatar> */}
            <div
                style={{
                    width: '160px', // Ajuste o tamanho conforme necessário
                    height: '100px',
                    margin: 'auto', // Centraliza com margem
                    backgroundImage: `url(${logoAscoprel})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
            ></div>

            <Typography
                sx={{
                    fontFamily: "'Roboto', sans-serif", fontWeight: 'bold',
                    fontSize: '2.5rem', color: '#141259', lineHeight: '1.5', 
                }}
            >
                <h1>Agendamento <br /> Ascoprel</h1>
            </Typography>
         
        </Box>
    );
}

export function Copyright(props) {
    return (
        <Typography variant="body2" color="white" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://www.copreltelecom.com.br/">
                Coprel Telecom
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}